export const getTopLink = () => '/';
// company
export const getCompanyLink = () => '/company';
// company_deposits
export const getCompanyDepositsLink = () => '/company_deposits';
// redeemable_store_coupon_histories
export const getRedeemableStoreCouponHistoriesLink = () => '/redeemable_store_coupon_histories';
// payment_reports
export const getPaymentReportLink = () => '/payment_reports';
